<template>
  <div class="ring-background">
    <div class="container grid md:mt-20 md:grid-cols-2 pb-8 md:pb-12">
      <div class="pb-12">
        <div class="text-blue pb-2 uppercase font-bold text-base">
          {{ $t('CreateProfile') }}
        </div>
        <h1 class="article-head-m pb-4">
          {{ $t('TryNonBinding') }}
        </h1>
        <i18n-t
          keypath="tryOneOrMoreOfOurPapersOrContantUs"
          tag="h2"
          class="body-m"
        >
          <template #email>
            <a
              class="underline"
              :href="`mailto:${config.public.site.primaryEmail}`"
              >{{ config.public.site.primaryEmail }}</a
            >
          </template>
          <template #phone>
            <a
              class="underline"
              :href="`tel:${config.public.site.primaryPhone}`"
              >{{ config.public.site.primaryPhone }}</a
            >
          </template>
        </i18n-t>
        <div class="pb-2 text-left">
          <ul class="list-none list-inside mt-5">
            <li
              v-for="(sellingPoint, index) in $tm('subscriptionSellingPoints')"
              :key="index"
            >
              {{ $rt(sellingPoint) }}
            </li>
          </ul>
        </div>
        <div class="mt-4 flex flex-col md:flex-row items-center gap-4">
          <NuxtLink class="w-full md:w-auto" to="#papers">
            <CommonButton
              size="xlarge"
              class="w-full md:w-auto"
              border="border-none"
              bg="bg-blue"
              text="text-white"
              text-hover="hover:text-white"
              bg-hover="hover:bg-denimblue"
              >{{ $t('chooseYourPapers') }}</CommonButton
            >
          </NuxtLink>
          <CommonButton
            size="xlarge"
            class="w-full md:w-auto"
            border="border-gray-300"
            bg="bg-white"
            text="text-black"
            text-hover="hover:text-black"
            bg-hover="hover:bg-gray-100"
            @click.native="$emit('showCallMeModal')"
            >{{ $t('CallMe') }}</CommonButton
          >
        </div>
      </div>
      <div>
        <img src="~/assets/images/altinget-float-double.png" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()
</script>

<style scoped>
.ring-background {
  background: url('~/assets/graphic/rings-large.svg') no-repeat center 20px;
}

li {
  @apply py-1;
  background: no-repeat url('@/assets/icons/checkmark.svg') left center;
  padding-left: 35px;
}
</style>
